import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started-with-docker"
    }}>{`Getting Started with Docker`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#docker"
        }}>{`Docker`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#docker-compose"
        }}>{`Docker Compose`}</a></li>
    </ul>
    <h2 {...{
      "id": "docker"
    }}>{`Docker`}</h2>
    <p>{`We'll use `}<inlineCode parentName="p">{`cezerin/cezerin`}</inlineCode>{` image.
`}<a parentName="p" {...{
        "href": "https://github.com/cezerin/docker-cezerin"
      }}>{`About image`}</a>{`.`}</p>
    <ol>
      <li parentName="ol">{`Run MongoDB`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`docker run --name store-db -v /var/www/store-db:/data/db -d mongo:latest
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Run Cezerin`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`docker run -d \\
--name store \\
--link store-db:db \\
-p 80:80 \\
-e DB_HOST=db \\
-e DB_PORT=27017 \\
-e DB_NAME=shop \\
-e DB_USER=user \\
-e DB_PASS=password \\
-v /var/www/store:/var/www/cezerin \\
cezerin/cezerin:latest
`}</code></pre>
    <p>{`Open http://localhost to see your store.
Dashboard - http://localhost/admin
API - http://localhost`}</p>
    <h2 {...{
      "id": "docker-compose"
    }}>{`Docker Compose`}</h2>
    <p>{`Create `}<inlineCode parentName="p">{`docker-compose.yml`}</inlineCode>{` by examples.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yml"
      }}>{`version: "3"

services:
  app:
    image: cezerin/cezerin
    environment:
      - DB_HOST=db
      - DB_PORT=27017
      - DB_NAME=shop
      - DB_USER=
      - DB_PASS=
    ports:
      - 4000:80
    volumes:
      - /var/www/store:/var/www/cezerin
    depends_on:
      - db
    restart: always

  db:
    image: mongo
    ports:
      - 27017
    volumes:
      - /var/www/store-db:/data/db
    restart: always
`}</code></pre>
    <p><inlineCode parentName="p">{`/var/www/store`}</inlineCode>{` - folder with Cezerin
`}<inlineCode parentName="p">{`/var/www/store-db`}</inlineCode>{` - folder with MongoDB data`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      